/**
 * isReadyForBulk — frontend mirror of the "cleared for bulk" gate.
 *
 * A Product Dev record is ready to graduate into a bulk purchase order when it
 * has reached the bulk-complete stage, been approved, and both sides have
 * agreed the price. `LinkedProductDevCard` computes the same predicate from a
 * server-side `priceAgreed` summary flag; this helper keeps the full-detail
 * surfaces (which have the raw `price_agreed_by_*` booleans) in lock-step
 * without another round-trip.
 *
 * Non-blocking: callers use this to surface a soft advisory, never to disable
 * the flow.
 */
export interface ReadyForBulkInput {
  stage: string;
  status: string;
  price_agreed_by_supplier: boolean;
  price_agreed_by_us: boolean;
}

export function isReadyForBulk(input: ReadyForBulkInput): boolean {
  return (
    input.stage === 'bulk_complete' &&
    input.status === 'approved' &&
    input.price_agreed_by_supplier &&
    input.price_agreed_by_us
  );
}
